import { render } from "./orderdetail.vue?vue&type=template&id=22a3a5d9&scoped=true&ts=true"
import script from "./orderdetail.vue?vue&type=script&lang=ts"
export * from "./orderdetail.vue?vue&type=script&lang=ts"

import "./orderdetail.vue?vue&type=style&index=0&id=22a3a5d9&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a3a5d9"]])

export default __exports__